import React from "react";
import { Route, Switch } from "react-router-dom";

import Components from "./components/index";
import CustomViews from "./customViews/index";
import Extensions from "./extensions/index";
import ExtraComponents from "./extraComponents/index";
import InBuiltApps from "./inBuiltApps/index";
import SocialApps from "./socialApps/index";
import Main from "./main/index";
import Documents from "./documents/index";
import UserPanel from "./UserPanel/index";
import Admin from "./Admin";
import moment from "moment";
import { expireRefreshToken } from "../api";

export function checkIsLogin() {
    if (window.location.href.includes('/order/verify'))
        return true;
    if (
        localStorage.getItem("accessToken") &&
        localStorage.getItem("accessToken").length > 0
    ) {
        let lastRefresh = localStorage.getItem("tokenDate");
        return true;
    }
    return false;
}
const App = ({ match }) => (
    <div className="gx-main-content-wrapper">
        <Switch>
            <Route path={`${match.url}main`} component={Main} />
            <Route
                path={`${match.url}userpanel`}
                component={
                    checkIsLogin()
                        ? UserPanel
                        : window.location.replace("/authorization/")
                }
            />
            <Route path={`${match.url}components`} component={Components} />
            <Route path={`${match.url}custom-views`} component={CustomViews} />
            <Route path={`${match.url}extensions`} component={Extensions} />
            <Route
                path={`${match.url}extra-components`}
                component={ExtraComponents}
            />
            <Route path={`${match.url}in-built-apps`} component={InBuiltApps} />
            <Route path={`${match.url}social-apps`} component={SocialApps} />
            <Route path={`${match.url}documents`} component={Documents} />
            <Route path={`${match.url}adminpanel`} component={Admin} />
        </Switch>
    </div>
);

export default App;
